import '../../../../js/resem-analytics.js';

export function trackOperations(operationType) {
    const labelElementKey = operationType + 'Button';
    analytics.submitEventAction(
        awp,
        analyticsObjects.actions.gotoAction,
        analyticsObjects.labelElements[labelElementKey]
    );
}
